import * as ActionTypes from './ActionTypes'
import { Map } from 'immutable'

import { PUSHER_CLUSTER, PUSHER_KEY } from '../constants'

const getInitialState = () => {
  return Map({
    key: PUSHER_KEY,
    cluster: PUSHER_CLUSTER,
  })
}

const reducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case ActionTypes.VNPUSHER_SET_CLUSTER:
      return state.set('cluster', action.cluster)
    case ActionTypes.VNPUSHER_SET_KEY:
      return state.set('key', action.key)
    default:
      return state
  }
}

export default reducer
